// /columns/groups.js
export const groupColumns = [
    { title: "ID", field: "_id", width: 10 },
    { title: "Group Name", field: "groupName", headerFilter: "input" },
    { title: "Institution", field: "institution", headerFilter: "input",width: 200  },
    {
      title: "Students",
      field: "students",
      formatter: (cell) => {
        const students = cell.getValue();
        return Array.isArray(students) ? students.length : 0;
      },
      width: 100,
      accessorClipboard: (value) => Array.isArray(value) ? value.length : 0,
    },
    { title: "Location", field: "location", headerFilter: "input" },
    { title: "Zipcode", field: "zipCode", headerFilter: "input" },
    { title: "Grade", field: "grade", headerFilter: "input" },
    { title: "Sector", field: "sector", headerFilter: "input" },
    {
      title: "Action",
      field: "action",
      width: 120,
      minWidth: 120,
      hozAlign: "center",
      headerSort: false,
      resizable: false,
      formatter: (cell) => {
        return `
          <div style="display: flex; gap: 4px; justify-content: center; align-items: center;">
            <button class="edit-btn" title="Edit group">
              <i class="bi bi-pencil-square"></i>
            </button>
            <button class="delete-btn" title="Delete group">
              <i class="bi bi-trash3"></i>
            </button>
          </div>
        `;
      },
      cellClick: (e, cell) => {
        const group = cell.getRow().getData();

        const tabulatorInstance = cell.getTable();
        const vueComponent = tabulatorInstance._component;

        if (!vueComponent) return;

        if (e.target.closest(".edit-btn")) {
          vueComponent.$emit("custom-edit", group);
        }

        if (e.target.closest(".delete-btn")) {
          vueComponent.$emit("custom-delete", group);
        }
      }
      ,
    },
  ];
  